<div class="hems-container flex flex-col">
  <div data-at-hems-dashboard-header class="dashboard-header">
    <h1>
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.DASHBOARD' | translate }}
    </h1>
    <button
      *ngIf="hocaFeatures$ | async | ready"
      class="settings-btn"
      data-at-hems-settings-button
      mat-stroked-button
      color="secondary"
      gtm="onOpen"
      gtmAction="Settings"
      gtmCategory="hems"
      (click)="openSettingsOverlay()"
    >
      <mat-icon>settings</mat-icon>
      <span>{{ '+HEMS.SETTINGS.TITLE' | translate }}</span>
    </button>
  </div>
  <app-energy-flow></app-energy-flow>
  <app-energy-history-chart></app-energy-history-chart>
</div>
